import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { Icon } from '../general/Icon';
import { FlexboxCenter, Flexbox } from '../general/Layout';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;

const PaginationWrapper = styled(FlexboxCenter)`
  grid-column: 2;
  flex-direction: row;
`;
const PaginationItem = styled(FlexboxCenter)`
  width: 1.5rem;
  height: 1.5rem;
  background-color: ${Colors.white};
  font-size: .875rem;

  &:not(last-child) {
    margin-right: .5rem;
  }

  cursor: pointer;

  &.active {
    background-color: ${Colors.primary};
    color: ${Colors.white};
    cursor: default;
    pointer-events: none;
  }
`;

export const CountLabel = styled(Flexbox)`
  justify-content: flex-end;

  font-size: .75rem;
`;

interface Props {
  page: number;
  pagesCount: number;
  onPageChange: (page: number) => void;
  countLabel?: string;
}
export const GenericListFooter: FC<Props> = ({ page, pagesCount, onPageChange, countLabel }) => {
  const items = [];
  if (pagesCount > 5) {
    if (page > 2) {
      if ((pagesCount - page) > 3) {
        items.push(0);
        for (let i = page-1; i < page+2; i++) {
          items.push(i);
        }
        items.push(pagesCount-1);
      } else {
        items.push(0);
        for (let i = 0; i < 4; i++) {
          items.push(pagesCount-4 + i);
        }
      }
    } else {
      for (let i = 0; i < 4; i++) {
        items.push(i);
      }
      items.push(pagesCount-1);
    }
  } else {
    for (let i = 0; i < pagesCount; i++) {
      items.push(i);
    }
  }

  return (
    <Wrapper>
      <PaginationWrapper>
        { items.length > 1 && items.map((i) => <PaginationItem key={i} className={page===i ? 'active' : ''} onClick={() => onPageChange(i)}>{i+1}</PaginationItem>) }
      </PaginationWrapper>
      {
        countLabel &&
        <CountLabel>{ countLabel }</CountLabel>
      }
    </Wrapper>
  );
};
